<template>
    <!-- <img src="/images/icons/user-icon.svg" loading="lazy" width="20" height="20" alt="user icon"/> -->
    <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M5.61546 5.27474C5.61546 2.91662 7.53258 0.999512 9.89072 0.999512C12.2489 0.999512 14.166 2.91662 14.166 5.27474C14.157 7.58787 12.3479 9.45997 10.0437 9.54098H9.98073C9.92673 9.53198 9.85472 9.53198 9.78272 9.54098C7.42457 9.45997 5.61546 7.58787 5.61546 5.27474Z"
            fill="#9A9A9A"
        />
        <path
            d="M5.32829 11.9341C7.85744 10.26 11.9527 10.26 14.4639 11.9341C15.5979 12.6902 16.219 13.7162 16.228 14.8233C16.228 15.9393 15.5979 16.9654 14.4639 17.7304C13.2038 18.5765 11.5477 18.9995 9.89157 18.9995C8.23547 18.9995 6.57936 18.5765 5.31928 17.7304C4.18521 16.9744 3.55518 15.9483 3.55518 14.8413C3.55518 13.7342 4.18521 12.6992 5.32829 11.9341Z"
            fill="#9A9A9A"
        />
    </svg>
</template>

<script>
export default {
    data() {
        return {};
    },
};
</script>
